// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"492":"fc0a0b7a","594":"d3afb38e","765":"ea9987a8","770":"2e02ed7a","980":"7112ac71"}[chunkId] + ".js";
};